<template>
  <div>
    <PublicShell :igreja="igreja" titulo="Cadastro de Criança" :valido="!!igrejaId" max-width="720px">
      <p class="pub-intro">Dados do responsável (pai ou mãe já cadastrado como membro):</p>
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm12 lg4>
            <v-select outlined dense v-model="responsavel.tipo" :items="tiposResponsavel" hide-details color="#00695C" label="RESPONSÁVEL*"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg8>
            <v-text-field light label="CPF DO RESPONSÁVEL*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details type="tel" v-model="responsavel.cpf" @change="consultaCPF(responsavel.cpf)" append-outer-icon="search"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <v-text-field light disabled v-model="responsavel.nome" label="NOME DO RESPONSÁVEL" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 lg12>
            <p class="pub-intro mt-2">Dados da criança:</p>
          </v-flex>
          <v-flex xs12 sm12 lg6>
            <v-text-field light :disabled="!responsavel.id" v-model="crianca.nome" label="NOME DA CRIANÇA*" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg3>
            <v-text-field type="tel" light :disabled="!responsavel.id" v-model="crianca.dataNascimento" label="DATA DE NASCIMENTO*" outlined color="#00695C" v-mask="'##/##/####'" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg3>
            <v-select outlined dense :disabled="!responsavel.id" v-model="crianca.sexo" :items="sexos" hide-details color="#00695C" label="SEXO*"></v-select>
          </v-flex>

          <v-flex xs12 sm12 lg6 v-if="redes.length">
            <v-select outlined dense :disabled="!responsavel.id" v-model="redeSelecionada" :items="redes" hide-details item-text="nome" item-value="id" color="#00695C" label="REDE (KIDS)" @input="carregaCelulas"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg6 v-if="redes.length">
            <v-select outlined dense :disabled="!redeSelecionada" v-model="crianca.celulaId" :items="celulas" hide-details item-text="nome" item-value="id" color="#00695C" label="CÉLULA"></v-select>
          </v-flex>

          <v-flex xs12 sm12 lg12>
            <v-checkbox v-model="crianca.aceiteLgpd" :disabled="!responsavel.id" hide-details class="mt-2">
              <template v-slot:label>
                <div>Concordo com o tratamento dos dados pessoais para fins de cadastro na igreja.</div>
              </template>
            </v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>

      <v-btn dark depressed block color="#00695C" rounded large class="mt-5" @click="salvaCrianca">Confirmar Cadastro</v-btn>
    </PublicShell>

        <v-dialog v-model="dialogoCadastroConcluido" persistent max-width="500px">
          <v-card>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="kc-texto" style="color:#00695C">Criança cadastrada com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Concluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoNaoCadastrado" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="kc-texto" style="color: #666">O CPF do responsável não possui cadastro na <strong>{{ igreja.nome }}</strong>. <a :href="`/cadastro-membro?igrejaId=${igrejaId}`">Clique aqui</a> e cadastre-se primeiro.<br><br>Depois, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoNaoCadastrado = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import axios from 'axios'
import PublicShell from '../../componentes/PublicShell.vue'

export default {
  name: 'CadastroCriancaPublico',
  components: { Snackbar, Loading, PublicShell },
  data() {
    return {
      igrejaId: '',
      igreja: {},
      responsavel: { tipo: '', cpf: '', nome: '', id: '' },
      tiposResponsavel: ['Mãe', 'Pai'],
      crianca: { nome: '', sexo: '', dataNascimento: '', celulaId: '', aceiteLgpd: null },
      redeSelecionada: '',
      redes: [],
      celulas: [],
      sexos: ['MASCULINO', 'FEMININO'],
      dialogoNaoCadastrado: false,
      dialogoCadastroConcluido: false,
      isLoading: false,
      fullPage: true,
    }
  },
  mounted() {
    this.igrejaId = this.$route.query.igrejaId || ''
    if (this.igrejaId) {
      this.carregaDados()
      this.carregaRedes()
    }
  },
  watch: {
    dialogoNaoCadastrado(val) { if (val === false) window.location.reload() },
  },
  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) this.igreja = response.data
      } catch (error) {
        this.igrejaId = ''
      } finally {
        this.isLoading = false
      }
    },
    async carregaRedes() {
      try {
        const response = await axios.post(baseApiUrl + 'Redes/listarPublicasPorTipo', { igrejaId: this.igrejaId, tipo: 'KIDS' })
        if (response.data) this.redes = response.data
      } catch (e) { this.redes = [] }
    },
    async carregaCelulas() {
      this.crianca.celulaId = ''
      this.celulas = []
      if (!this.redeSelecionada) return
      try {
        const response = await axios.post(baseApiUrl + 'Celulas/listarPorRedePublico', null, { params: { redeId: this.redeSelecionada } })
        if (response.data) this.celulas = response.data
      } catch (e) { this.celulas = [] }
    },
    async consultaCPF(cpf) {
      if (!cpf) return
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/buscaPublicaCpf', null, { params: { cpf: cpf, igrejaId: this.igrejaId } })
        .then(response => {
          if (response.data && response.data.id) {
            this.responsavel.nome = response.data.nome
            this.responsavel.id = response.data.id
          } else {
            this.dialogoNaoCadastrado = true
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao consultar o CPF. Tente novamente.', 'ERRO')
        })
    },
    closeDialog() { window.location.reload() },
    async salvaCrianca() {
      const vm = this
      if (!this.responsavel.id || !this.responsavel.tipo || !this.crianca.nome || !this.crianca.sexo || !this.crianca.dataNascimento || !this.crianca.aceiteLgpd) {
        vm.$refs.chamaSnackbar.snack('#F9A825', 'Preencha todos os campos obrigatórios (*)!', 'ATENÇÃO')
        return
      }
      const dados = {
        nome: this.crianca.nome.toUpperCase(),
        sexo: this.crianca.sexo,
        dataNascimento: this.crianca.dataNascimento,
        tipo: 'CONGREGADO',
        igrejaId: this.igrejaId,
        aceiteLgpd: this.crianca.aceiteLgpd,
      }
      if (this.crianca.celulaId) dados.celulaId = this.crianca.celulaId
      if (this.responsavel.tipo === 'Mãe') dados.maeId = this.responsavel.id
      else dados.paiId = this.responsavel.id

      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Membros/salvarCriancaPublico', dados)
        if (response.data) this.dialogoCadastroConcluido = true
      } catch (e) {
        vm.$refs.chamaSnackbar.snack('#EF5350', 'Problema ao cadastrar. Verifique os dados e tente novamente.', 'DESCULPE')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.pub-intro { color: #5b6b67; margin: 0 0 6px; font-size: .95rem; }
.kc-texto { font-weight: bold; color: #00253E; font-size: 17px; }
</style>
